import { useEffect, useLayoutEffect, useRef, useState } from 'react';
import { createPortal } from 'react-dom';

export default function OverflowMenu({ anchorRect, items, onClose }) {
  const ref = useRef(null);
  const [pos, setPos] = useState({ top: 0, left: 0 });

  useLayoutEffect(() => {
    if (!anchorRect) return;
    const w = 180;
    const margin = 8;
    let left = anchorRect.right - w;
    if (left < margin) left = margin;
    if (left + w > window.innerWidth - margin) left = window.innerWidth - margin - w;
    let top = anchorRect.bottom + 4;
    const estH = items.length * 36 + 12;
    if (top + estH > window.innerHeight) top = anchorRect.top - estH;
    if (top < margin) top = margin;
    setPos({ top, left });
  }, [anchorRect, items.length]);

  useEffect(() => {
    function onDoc(e) { if (ref.current && !ref.current.contains(e.target)) onClose(); }
    function onKey(e) { if (e.key === 'Escape') onClose(); }
    document.addEventListener('mousedown', onDoc);
    document.addEventListener('keydown', onKey);
    return () => { document.removeEventListener('mousedown', onDoc); document.removeEventListener('keydown', onKey); };
  }, [onClose]);

  return createPortal(
    <div ref={ref} className="overflow-menu" style={{ top: pos.top, left: pos.left }} role="menu">
      {items.map(it => (
        <button
          key={it.key}
          type="button"
          className={`overflow-item ${it.danger ? 'danger' : ''}`}
          disabled={it.disabled}
          onClick={() => { onClose(); it.onClick?.(); }}
          role="menuitem"
        >
          {it.label}
        </button>
      ))}
    </div>,
    document.body
  );
}
